import { generateS3ItemPreSignedUrlV1 } from "@/lib/data/requests/s3";
import { getFileNameParts } from "@/lib/utils/matterFile";

const messageMediaExtensionByContentType: Record<string, string> = {
  "image/gif": "gif",
  "image/heic": "heic",
  "image/heif": "heif",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/tiff": "tiff",
  "text/vcard": "vcf",
  "text/x-vcard": "vcf",
  "video/mp4": "mp4",
  "video/quicktime": "mov",
  "video/webm": "webm",
  "video/3gpp": "3gp",
};

export const getMessageMediaFileName = (s3Key: string, contentType: string) => {
  const sourceName = s3Key.split("/").pop() || "attachment";
  if (getFileNameParts(sourceName).fileExtension) return sourceName;
  const extension =
    messageMediaExtensionByContentType[
      contentType.split(";")[0].trim().toLowerCase()
    ];
  return extension ? `${sourceName}.${extension}` : sourceName;
};

export const downloadMessageMediaFile = async (
  s3Key: string,
): Promise<File> => {
  const presignedUrlResponse = await generateS3ItemPreSignedUrlV1(
    "message-media",
  )({
    clientMethod: "get_object",
    key: s3Key,
  });
  const response = await fetch(presignedUrlResponse.data.presignedUrl);

  if (!response.ok) {
    throw new Error("The SMS attachment download failed. Please try again.");
  }

  const blob = await response.blob();
  return new File([blob], getMessageMediaFileName(s3Key, blob.type), {
    type: blob.type,
  });
};
